import { render, staticRenderFns } from "./WHO5BreakdownSlide.vue?vue&type=template&id=2bcab76f&scoped=true&"
import script from "./WHO5BreakdownSlide.vue?vue&type=script&lang=js&"
export * from "./WHO5BreakdownSlide.vue?vue&type=script&lang=js&"
import style0 from "./WHO5BreakdownSlide.vue?vue&type=style&index=0&id=2bcab76f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcab76f",
  null
  
)

export default component.exports